const security = [{
  desc: '获取商户安全配置',
  options: {
    url: '/securityConfig/getPartnerSecurityConfig',
    method: 'post'
  }
}, {
  desc: '新增or编辑商户安全配置',
  options: {
    url: '/securityConfig/saveSecurityConfig',
    method: 'post'
  }
}, {
  desc: '商户数据安全机制',
  options: {
    url: '/securityConfig/queryPartnerSecurityConfig',
    method: 'post'
  }
}, {
  desc: '新增或编辑数据安全机制',
  options: {
    url: '/securityConfig/savePartnerSecurityConfig',
    method: 'post'
  }
}, {
  desc: '编辑商户配置是否为简洁模式',
  options: {
    url: '/securityConfig/savePartnerIsDataAuthority',
    method: 'post'
  }
}]
export default security



// WEBPACK FOOTER //
// ./src/api/security.js